export default __webpack_public_path__ + "static/image1-156f5ac62732addca9cbf6d9b6e442d6.jpeg";